var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 12C2.33301 8.22876 2.33301 6.34315 3.50458 5.17157C4.67615 4 6.56177 4 10.333 4H14.333C18.1042 4 19.9899 4 21.1614 5.17157C22.333 6.34315 22.333 8.22876 22.333 12C22.333 15.7712 22.333 17.6569 21.1614 18.8284C19.9899 20 18.1042 20 14.333 20H10.333C6.56177 20 4.67615 20 3.50458 18.8284C2.33301 17.6569 2.33301 15.7712 2.33301 12Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 8L8.4919 9.79908C10.3285 11.3296 11.2469 12.0949 12.333 12.0949C13.4192 12.0949 14.3375 11.3296 16.1741 9.79908L18.333 8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.a8d2fefe49f579fec230a7a1809ef840.svg";
export { ForwardRef as ReactComponent };